module.exports = __webpack_public_path__ + "static/media/icon-crown-03.4882edf2.svg";